import { render, staticRenderFns } from "./DisposePropertyList.vue?vue&type=template&id=36463fd6"
import script from "./DisposePropertyList.vue?vue&type=script&lang=js"
export * from "./DisposePropertyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports